import { render, staticRenderFns } from "./DucNotice.vue?vue&type=template&id=0736440e&scoped=true"
import script from "./DucNotice.vue?vue&type=script&lang=js"
export * from "./DucNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0736440e",
  null
  
)

export default component.exports